<div class="account-reactivation-window-container modal-window-container fx-cover fx-center-all" #container (click)="closeWindow()">
    <div class="account-reactivation-window-inner modal-window-inner" #window (click)="$event.stopPropagation()">
        <button type="button" class="btn-small nu-btn-icon account-reactivation-window-close" (click)="closeWindow()">
            <svg class="nu-icon nu-icon-small nu-ic-close">
                <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-close"></use>
            </svg>
        </button>

        <div class="account-reactivation-window-icon" aria-hidden="true">
            <span></span>
            <span></span>
        </div>

        <h2 class="account-reactivation-window-heading">{{ heading }}</h2>
        <p class="account-reactivation-window-description">{{ description }}</p>

        <button
            type="button"
            class="btn-medium btn-primary account-reactivation-window-action"
            [disabled]="isSubmitting"
            (click)="openPrimaryAction()">
            <span
                *ngIf="isSubmitting && !isPaymentFailed"
                class="account-reactivation-window-action-spinner"
                aria-hidden="true"></span>
            <span *ngIf="!isSubmitting || isPaymentFailed">{{ actionLabel }}</span>
        </button>
    </div>
</div>
